// extracted by mini-css-extract-plugin
module.exports = {"bottom-column-wapper":"fD","bottomColumnWapper":"fD","bottom-column-panel":"fE","bottomColumnPanel":"fE"};